module.exports = __webpack_public_path__ + "img/MOUSTACHES SET 2.c440175.svg";